<template>
  

      <div class="col-auto col-width-standard border-right">
        <div class="w-100 h-25 text-center">
          <strong>Performance</strong>
        </div>
        <div class="d-flex h-75">
          <div class="overview-chart-fixed-width align-self-center">
            <doughnutChart
              :chart-data="engagement.performance"
              :options="engagement.chartOptions"
              :textMiddle="engagement.performanceValue"
            ></doughnutChart>
          </div>
          <div class="overview-info-fixed-width pl-3 align-self-center">
            <div class="row flex-nowrap justify-content-between">
              <div class="col">Performance:</div>
              <div class="col text-right">50%</div>
            </div>
          </div>
        </div>
      </div>

      
    
</template>

<script>
import doughnutChart from "@/components/engagement/charts/percentageDoughnutChart.js";
import {Doughnut,mixins} from 'vue-chartjs'

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: ['engagement', 'chartData'],
  components: {
    doughnutChart,
  },
  
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewBar.scss";
</style>